import React from 'react';

export const SuccesIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <g id="Outline/checkmark_circle">
        <path
          id="Union"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 2.8616C6.47715 2.8616 2 7.2253 2 12.6082C2 17.9911 6.47715 22.3548 12 22.3548C17.5228 22.3548 22 17.9911 22 12.6082C22 7.2253 17.5228 2.8616 12 2.8616ZM12 4.81092C16.4183 4.81092 20 8.30188 20 12.6082C20 16.9145 16.4183 20.4055 12 20.4055C7.58172 20.4055 4 16.9145 4 12.6082C4.00496 8.30388 7.58378 4.81575 12 4.81092ZM18 10.0936L16.59 8.70956L11 14.1579L8.41 11.6433L7 13.0175L11 16.9162L18 10.0936Z"
          fill="#139854"
        />
      </g>
    </svg>
  );
};
